<template>
  <qd-message
    :title="sprintTitle"
    :closable="title == sprintTitle"
    type="is-default"
    aria-close-label="Close message">
    <div v-html="sprint" class="height-max-57vh"></div>
  </qd-message>
</template>

<script>
export default {
  name: 'SprintCard',
  props: {
    data: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    sprintTitle() {
      return this.title || this.data.titre;
    },
    sprint() {
      if (!this.data.sprint.toString().startsWith('<!doctype html><html><head>')) {
        return this.insertCssInSprint(this.data.sprint);
      }
      return this.data.sprint;
    },
  },
  methods: {
    insertCssInSprint(content) {
      if (!content) return null;
      const target = '</title>';
      const modifCss = '<style>.es-content-body{width: 75% !important;} .es-content-body> tbody > tr:not(:first-child) .adapt-img{ width: 90% !important; }</style>';
      const index = content.indexOf(target);
      const result = content.slice(0, index + target.length)
        + modifCss
        + content.slice(index + target.length, content.length);
      return result.replaceAll('width:600px', 'width:95%').replaceAll('width="530"', 'width="85%"');
    },
  },
};
</script>
